<template>
    <div class="api-day-toggler-by-launch-box">
        <b-form-checkbox v-model="workingValue" :disabled="isProcessing" @change="callForUpdate" v-if="modoAgenda == 'Normal'"/>
        <b-button v-else-if="modoAgenda == 'Múltiple'" size="sm">{{ cantidad }}</b-button>
        <!-- {{workingValue}} -->
        <!-- [{{day}}] -->
        <!-- [{{cantidad}}] -->
        <!-- [{{presenciaId}}] -->
    </div>
</template>

<script>
import moment from 'moment'
import { toggleDateInLunchbox } from './archetype'
export default {
    name: 'api-day-toggler-by-launch-box',
    props: {
        modoAgenda: {
            type: String,
            default: 'Normal'
        },
        selectFilters: {
            type: Object
        },
        presenciaId: {
            type: [Number, String]
        },
        day: {
            type: [Number, String, Date]
        },
        cantidad: {
            type: [Number, String]
        }
    },
    data: () => {
        return {
            workingValue: null,
            isProcessing: false
        }
    },
    methods: {
        async callForUpdate() {
            this.isProcessing = true;

            let addDays = (dayNameInSpanish) => {
                let matrix = {
                    'Lunes': 0,
                    'Martes': 1,
                    'Miércoles': 2,
                    'Jueves': 3,
                    'Viernes': 4,
                }
                return moment(this.selectFilters.fechas.inicio).add(matrix[dayNameInSpanish], "days").format("YYYY-MM-DD");
            };

            let response = await toggleDateInLunchbox({
                date: addDays(this.day),
                presenciaId: this.presenciaId
            })
            if(response){
                this.workingValue = response.data.writeStatus
                this.$emit('reload', response)
            }
            this.isProcessing = false;
        }
    },
    mounted(){
        this.workingValue = (parseInt(this.cantidad)) ? true : false
    }
}
</script>

<style lang="less">
.api-day-toggler-by-launch-box {
    text-align: center;
    display: inline-block;
}
</style>